/**
 * @module cercaliagl/view/SVGUtils
 */

import IconsSVG from './IconsSVG';

/**
 * @param {string} svgPaths SVGPaths
 * @return {string} SVG
 */
export function createSVGIconFromPath(svgPaths) {
  const innerSvg = svgPaths.indexOf('<') === -1 ? `<path d="${svgPaths}"/>` : svgPaths;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">${innerSvg}</svg>`;
}

/**
 * @param {string} iconName Icon name defined in IconsSVG
 * @return {string} SVG html format.
 */
export function createSVGIcon(iconName) {
  const svgPaths = IconsSVG[iconName] ? IconsSVG[iconName].join('') : '';
  return createSVGIconFromPath(svgPaths);
}

/**
 * @param {string} iconName Icon name
 * @param {number} [numPaths] Number of paths
 */
export function createSpanIconByNumPath(iconName, numPaths = 0) {
  const html = `<span class="${iconName}">${Array(numPaths).fill().map((_, i) => `<i class="path${i + 1}"></i>`).join('')}</span>`;
  return html;
}
